/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  ResolveChallengeForm,
  ResolveChallengeForm$Outbound,
  ResolveChallengeForm$outboundSchema,
} from "../components/resolvechallengeform.js";

export type ResolveChallengeSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type ResolveChallengeRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  resolveChallengeForm: ResolveChallengeForm;
};

/** @internal */
export type ResolveChallengeSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ResolveChallengeSecurity$outboundSchema: z.ZodMiniType<
  ResolveChallengeSecurity$Outbound,
  ResolveChallengeSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function resolveChallengeSecurityToJSON(
  resolveChallengeSecurity: ResolveChallengeSecurity,
): string {
  return JSON.stringify(
    ResolveChallengeSecurity$outboundSchema.parse(resolveChallengeSecurity),
  );
}

/** @internal */
export type ResolveChallengeRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  ResolveChallengeForm: ResolveChallengeForm$Outbound;
};

/** @internal */
export const ResolveChallengeRequest$outboundSchema: z.ZodMiniType<
  ResolveChallengeRequest$Outbound,
  ResolveChallengeRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    resolveChallengeForm: ResolveChallengeForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      resolveChallengeForm: "ResolveChallengeForm",
    });
  }),
);

export function resolveChallengeRequestToJSON(
  resolveChallengeRequest: ResolveChallengeRequest,
): string {
  return JSON.stringify(
    ResolveChallengeRequest$outboundSchema.parse(resolveChallengeRequest),
  );
}
